module.exports = __webpack_public_path__ + "img/symbol_1.a47ed1a7.png";